import {
  generalAdabyronBehaviour,
  USER_TYPES,
} from '../../utils/adaByron';
import { MethodType, Context } from '../../utils/types';

export enum PATHS {
  GET_OBD = 'gestioncredenciales/onboarding/enrutado',
  PIN_GENERATE = 'gestioncredenciales/onboarding/pin/generar',
  PIN_VALIDATE = 'gestioncredenciales/onboarding/pin/validar',
  OBD_COMPLETE = 'gestioncredenciales/onboarding/upgrade',
  CHECK_OBD = 'gestioncredenciales/onboarding/comprobar',
}

export const getOBD = (
  data: {
    forzarOBD: boolean;
    origen: string;
    destino: string,
    destino2: string,
    customerAccountId: string;
  },
  context: Context,
  idFront = 'TG',
): Promise<unknown> => {
  const { forzarOBD, destino, destino2, origen, customerAccountId } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.GET_OBD,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'MANAGER.GET_OBD',
    mockedInfo: 'getOBD',
    requestObject: {
      forzarOBD: forzarOBD,
      destino: destino,
      destino2: destino2,
      origen: origen,
      customerAccountId: customerAccountId,
    },
    methodType: MethodType.POST,
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
    telcoHostVersion: 2,
  });
};

export const pinGenerate = (
  data: {
    verifiedContactMeanId?: string;
    subscribedLineId?: string;
    securityMediumType: string;
    verificarContacto: boolean;
    vulnerableCode?: string;
  },
  context: Context,
  idFront = 'TG',
): Promise<unknown> => {
  const {
    verifiedContactMeanId,
    subscribedLineId,
    securityMediumType,
    verificarContacto,
    vulnerableCode,
  } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.PIN_GENERATE,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'MANAGER.PIN_GENERATE',
    mockedInfo: 'pinGenerate',
    methodType: MethodType.POST,
    requestObject: {
      verifiedContactMeanId: verifiedContactMeanId,
      subscribedLineId: subscribedLineId,
      securityMediumType: securityMediumType,
      verificarContacto: verificarContacto,
      vulnerableCode: vulnerableCode || "6",
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
    telcoHostVersion: 2,
  });
};

export const pinValidate = (
  data: {
    pin: string;
    verificarContacto: boolean;
  },
  context: Context,
  idFront = 'TG',
): Promise<unknown> => {
  const { pin, verificarContacto } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.PIN_VALIDATE,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'MANAGER.PIN_VALIDATE',
    mockedInfo: 'pinValidate',
    methodType: MethodType.POST,
    requestObject: {
      pin: pin,
      verificarContacto: verificarContacto,
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
    telcoHostVersion: 2,
  });
};

export const obdComplete = (
  data: {
    code: string;
    state: string;
    errorDaon: boolean;
  },
  context: Context,
  idFront = 'TG',
): Promise<unknown> => {
  const { code, state, errorDaon } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.OBD_COMPLETE,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'MANAGER.OBD_COMPLETE',
    mockedInfo: 'obdComplete',
    methodType: MethodType.POST,
    requestObject: {
      code: code,
      state: state,
      errorDaon: errorDaon,
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
    telcoHostVersion: 2,
  });
};

export const checkObd = (
  context: Context,
  idFront = 'TG',
): Promise<unknown> => {
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.CHECK_OBD,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'MANAGER.CHECK_OBD',
    mockedInfo: 'checkObd',
    methodType: MethodType.GET,
  });
};
